module.exports = __webpack_public_path__ + "static/media/img222.3813a825.jpg";